<template>
  <div
    v-if="visible"
    :class="['task-detail-plan-section', rootClass]"
    :data-layout-key="sectionKey"
  >
    <div class="task-detail-plan-section-header-wrap">
      <slot name="header" />
      <span
        v-if="blocked"
        class="task-section-plan-lock"
        :title="t('kanban.taskDetail.planSectionLock')"
        :aria-label="t('kanban.taskDetail.planSectionLock')"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          />
        </svg>
      </span>
    </div>

    <PlanFeatureGate
      v-if="$slots.body"
      :blocked="blocked && bodyExpanded"
      :title="gateTitle"
      :description="gateDescription"
      class="task-section-plan-gate"
    >
      <slot name="body" />
    </PlanFeatureGate>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import PlanFeatureGate from './plan/PlanFeatureGate.vue'

const { t } = useI18n()

defineProps({
  visible: { type: Boolean, default: true },
  sectionKey: { type: String, required: true },
  blocked: { type: Boolean, default: false },
  /** Quando false (seção minimizada), o overlay de plano não aparece */
  bodyExpanded: { type: Boolean, default: true },
  gateTitle: { type: String, default: 'Recurso bloqueado no plano atual' },
  gateDescription: {
    type: String,
    default: 'O plano do dono deste workspace não inclui esta opção.'
  },
  rootClass: { type: String, default: 'mb-4' }
})
</script>

<style scoped>
.task-detail-plan-section-header-wrap {
  position: relative;
}

.task-section-plan-lock {
  position: absolute;
  right: 2.5rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  color: var(--accent-primary);
  opacity: 0.9;
  pointer-events: none;
}

.task-section-plan-lock svg {
  width: 1rem;
  height: 1rem;
}

.task-section-plan-gate:deep(.plan-feature-gate.is-blocked) {
  min-height: 160px;
}

.task-section-plan-gate:deep(.plan-feature-gate.is-blocked .plan-feature-gate-content) {
  min-height: 160px;
}
</style>
